"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactSelectComponents = void 0;
// These components are used in sdk-react and swaga.
// We export them from our ui library to avoid installing multiple packages of react-select.
var react_select_1 = require("react-select");
Object.defineProperty(exports, "ReactSelectComponents", { enumerable: true, get: function () { return react_select_1.components; } });
//# sourceMappingURL=react-select.js.map